// src/api/user.js
import axios from "../utils/request";
const apiPrefix = "/user";

export const fetchCurrentUser = () => {
  return axios.get(`${apiPrefix}/me`);
};
export const changePassword = (data) => {
  return axios.post(`${apiPrefix}/change-password`, data);
};
export const getUserList = (data) => axios.post(`${apiPrefix}/list`, data);
export const getUserDetail = (id) => axios.get(`${apiPrefix}/${id}`);
export const searchUsers = (query) =>
  axios.get(`${apiPrefix}/search`, { params: { q: query } });
export const userRegister = (data) => axios.post(`${apiPrefix}/register`, data);
export const userLogin = (data) => axios.post(`${apiPrefix}/login`, data);
export const updateUser = (id, data) => axios.put(`${apiPrefix}/${id}`, data);

export const registerCustomer = (data) =>
  axios.post(`${apiPrefix}/customers`, data);
export const getCustomerRecord = (id) => axios.get(`${apiPrefix}/customers/${id}`);
export const updateCustomerRecord = (id, data) =>
  axios.put(`${apiPrefix}/customers/${id}`, data);

export const requestIdentityUploadToken = (files) =>
  axios.post("/files/upload-token", { files });

export const confirmIdentityFile = (data) =>
  axios.post("/files/confirm", data);

export const deleteIdentityFile = (fileId) =>
  axios.delete(`/files/${fileId}`);

export const getUploadedFile = (fileId) => axios.get(`/files/${fileId}`);

export const renameUploadedFile = (fileId, data) =>
  axios.patch(`/files/${fileId}`, data);

export const requestFileUploadToken = (data) =>
  axios.post("/files/upload-token", data);
